module.exports = __webpack_public_path__ + "c2fec5b3de0fa7fe43b8f92e1cd6b6c1.png";